import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import backk from './images/backk.png'; 

const SetUpp = () => {
  const navigate = useNavigate();
  const [gDriveLink, setGDriveLink] = useState('');
  const [message, setMessage] = useState('');
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false); // Track submission status

  useEffect(() => {
    const userEmail = sessionStorage.getItem('userEmail');
    if (!userEmail) {
      navigate('/signin'); // Redirect to Sign In if no email
    } else {
      setEmail(userEmail); // Set the email state
    }
  }, [navigate]);

  const handleGDriveLinkChange = (e) => {
    setGDriveLink(e.target.value);
  };

  const handleSubmit = async () => {
    if (!gDriveLink) {
      setMessage('Please enter the Google Drive link');
      return;
    }

    const sqlQuery = 'INSERT INTO RosaS (Gmail, GDriveLink) VALUES (%s, %s)';
    const values = [email, gDriveLink];

    try {
      const response = await fetch('https://www.d-rosa.ai/DBWRTAPI', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          query: sqlQuery,
          values: values,
        }),
      });

      const result = await response.json();
      setMessage(result.message || 'Data inserted successfully');

      // If submission is successful, disable the Submit button
      if (result.message === 'Data inserted successfully') {
        alert('Data inserted successfully');
        setIsSubmitted(true); // Disable the Submit button
      }
    } catch (error) {
      setMessage('Error inserting data: ' + error.message);
    }
  };

  const handleBackClick = () => {
    navigate(-1);
  };

  const buttonStyle = {
    backgroundColor: '#E11584',
    color: '#fff',
    padding: '10px 20px',
    fontSize: '16px',
    border: 'none',
    borderRadius: '5px',
    cursor: isSubmitted ? 'not-allowed' : 'pointer', // Change cursor when disabled
    marginTop: '20px',
    width: '150px',
    opacity: isSubmitted ? 0.6 : 1, // Dim button when disabled
  };

  const headingStyle = {
    color: '#E11584',
    fontSize: '32px',
    fontWeight: 'bold',
    marginBottom: '40px',
  };

  const inputStyle = {
    padding: '10px',
    fontSize: '16px',
    width: '300px',
    marginBottom: '20px',
    borderRadius: '5px',
    border: '1px solid #ccc',
  };

  return (
    <div
      style={{
        background: 'linear-gradient(to bottom, #fff7ad, #ffa9f9)',
        minHeight: '100vh',
        padding: '20px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
      }}
    >
      <h2 style={headingStyle}>SetUp Screen</h2>

      {email && (
        <p
          style={{
            color: '#E11584',
            fontSize: '20px',
            textAlign: 'center',
            marginBottom: '20px',
          }}
        >
          Signed in as: {email}
        </p>
      )}

      <div>
        <input
          type="text"
          value={gDriveLink}
          onChange={handleGDriveLinkChange}
          placeholder="Enter GDrive link"
          style={inputStyle}
          disabled={isSubmitted} // Disable input after submission
        />
      </div>

      <button
        style={buttonStyle}
        onClick={handleSubmit}
        disabled={isSubmitted} // Disable button after submission
      >
        Submit
      </button>

      <br />
      <br />
      <button
        type="button"
        onClick={handleBackClick}
        style={{
          backgroundColor: 'transparent',
          border: 'none',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          marginTop: '20px',
        }}
      >
        <img src={backk} width="30" height="40" alt="Back" />
      </button>

      {message && <p>{message}</p>}
    </div>
  );
};

export default SetUpp;
